import React from "react";
import api from "../services/api";

export default function DeviceTable({ devices = [], onReseted }) {
  const handleReset = async (deviceId) => {
    if (!window.confirm(`Reset count for ${deviceId}?`)) return;
    try {
      await api.post(`/devices/reset/${deviceId}`);
      onReseted && onReseted();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div style={{ marginTop: 20, background: "#fff", padding: 16, borderRadius: 8, boxShadow: "0 5px 15px rgba(0,0,0,0.05)" }}>
      <h3>Devices</h3>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={{ textAlign: "left", padding: 8 }}>Device ID</th>
            <th style={{ textAlign: "left", padding: 8 }}>Count</th>
            <th style={{ textAlign: "left", padding: 8 }}>Limit</th>
            <th style={{ textAlign: "left", padding: 8 }}>Status</th>
            <th style={{ textAlign: "left", padding: 8 }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {devices.map((d) => (
            <tr key={d.deviceId} style={{ borderTop: "1px solid #eee" }}>
              <td style={{ padding: 8 }}>{d.deviceId}</td>
              <td style={{ padding: 8 }}>{d.count}</td>
              <td style={{ padding: 8 }}>{d.limit}</td>
              <td style={{ padding: 8 }}>{d.status}</td>
              <td style={{ padding: 8 }}>
                <button onClick={() => handleReset(d.deviceId)} style={{ padding: "6px 10px" , background: "#f44336", color: "#fff", border: "none", borderRadius: "20px" }}>Reset</button>
              </td>
            </tr>
          ))}
          {devices.length === 0 && (
            <tr>
              <td colSpan={5} style={{ padding: 12, color: "#777" }}>No devices registered</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
